import "./BenefitsBanner.css";
import practitionerIcon from "../assets/icons/banner_practitioner.svg";
import formulatedIcon from "../assets/icons/banner_formulated.svg";
import deliveryIcon from "../assets/icons/banner_delivery.svg";
import { useEffect, useRef } from "react";

const ITEMS = [
  {
    src: practitionerIcon,
    alt: "Practitioner Reviewed",
    label: "Practitioner Reviewed",
  },
  { src: formulatedIcon, alt: "Custom Formulated", label: "Custom Formulated" },
  {
    src: deliveryIcon,
    alt: "Delivered to your door",
    label: "Delivered to your door",
  },
];

function BenefitsBanner() {
  const trackRef = useRef(null);
  const rafRef = useRef(null);

  useEffect(() => {
    const track = trackRef.current;

    const init = () => {
      const original = track.querySelector(".benefits-banner__group");
      const groupW = original.getBoundingClientRect().width;

      // Remove old clones if re-initialising
      track
        .querySelectorAll(".benefits-banner__group--clone")
        .forEach((el) => el.remove());

      // Fill at least 3× the screen width so there is NEVER a gap
      const needed = Math.ceil((window.innerWidth * 3) / groupW) + 1;
      for (let i = 0; i < needed; i++) {
        const clone = original.cloneNode(true);
        clone.classList.add("benefits-banner__group--clone");
        clone.setAttribute("aria-hidden", "true");
        track.appendChild(clone);
      }

      let x = 0;
      cancelAnimationFrame(rafRef.current);

      const animate = () => {
        x -= 1;
        if (x <= -groupW) x = 0;
        track.style.transform = `translateX(${x}px)`;
        rafRef.current = requestAnimationFrame(animate);
      };

      animate();
    };

    document.fonts.ready.then(init);
    return () => cancelAnimationFrame(rafRef.current);
  }, []);

  return (
    <div className="benefits-banner">
      <div className="benefits-banner__track" ref={trackRef}>
        <div className="benefits-banner__group">
          {ITEMS.map((item, i) => (
            <span key={i} style={{ display: "contents" }}>
              <div className="benefits-banner__item">
                <img
                  src={item.src}
                  alt={item.alt}
                  className="benefits-banner__icon"
                />
                <span className="benefits-banner__label">{item.label}</span>
              </div>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}

export default BenefitsBanner;
